export default __webpack_public_path__ + "static/media/Viki_Icon.38d059d3.png";